// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-pager";
function UserHierarchicalPermissionViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.User = parent;
    self.TabPage = tabPage;
    var _removeMessageUserMandator = Bao.Session.GetMessage("RemoveMessageUserMandator");
    var _removeMessageUserCustomer = Bao.Session.GetMessage("RemoveMessageUserCustomer");
    var _removeMessageUserLocation = Bao.Session.GetMessage("RemoveMessageUserLocation");
    var _removeMessageUserAccountAssignment = Bao.Session.GetMessage("RemoveMessageUserAccountAssignment");
    self.UserMandatorPageSize = ko.observable(20);
    self.UserMandatorPageIndex = ko.observable(0);
    self.UserMandatorPageIndex.subscribe(function () {
        self.GetUserMandatorCollection(false);
    });
    self.UserMandatorTotalRows = ko.observable(0);
    self.UserMandatorSorting = ko.observableArray();
    self.UserMandatorSorting.subscribe(function () {
        self.GetUserMandatorCollection(false);
    });
    self.UserMandatorCollection = ko.observableArray([]);
    self.SelectUserMandatorRow = function (item) {
        self.SelectedUserMandatorRow(item);
        return true;
    };
    self.SelectedUserMandatorRow = ko.observable();
    self.SelectedUserMandatorRow.subscribe(function () {
        self.GetUserCustomerCollection(true);
        self.ToggleToolbarButtons();
    });
    self.UserCustomerPageSize = ko.observable(20);
    self.UserCustomerPageIndex = ko.observable(0);
    self.UserCustomerPageIndex.subscribe(function () {
        self.GetUserCustomerCollection(false);
    });
    self.UserCustomerTotalRows = ko.observable(0);
    self.UserCustomerSorting = ko.observableArray();
    self.UserCustomerSorting.subscribe(function () {
        self.GetUserCustomerCollection(false);
    });
    self.UserCustomerCollection = ko.observableArray([]);
    self.SelectUserCustomerRow = function (item) {
        self.SelectedUserCustomerRow(item);
        return true;
    };
    self.SelectedUserCustomerRow = ko.observable();
    self.SelectedUserCustomerRow.subscribe(function () {
        self.GetUserLocationCollection(true);
        self.GetUserAccountAssignmentCollection(true);
        self.ToggleToolbarButtons();
    });
    self.UserLocationPageSize = ko.observable(20);
    self.UserLocationPageIndex = ko.observable(0);
    self.UserLocationPageIndex.subscribe(function () {
        self.GetUserLocationCollection(false);
    });
    self.UserLocationTotalRows = ko.observable(0);
    self.UserLocationSorting = ko.observableArray();
    self.UserLocationSorting.subscribe(function () {
        self.GetUserLocationCollection(false);
    });
    self.UserLocationCollection = ko.observableArray([]);
    self.SelectUserLocationRow = function (item) {
        self.SelectedUserLocationRow(item);
        return true;
    };
    self.SelectedUserLocationRow = ko.observable();
    self.SelectedUserLocationRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.UserAccountAssignmentPageSize = ko.observable(20);
    self.UserAccountAssignmentPageIndex = ko.observable(0);
    self.UserAccountAssignmentPageIndex.subscribe(function () {
        self.GetUserAccountAssignmentCollection(false);
    });
    self.UserAccountAssignmentTotalRows = ko.observable(0);
    self.UserAccountAssignmentSorting = ko.observableArray();
    self.UserAccountAssignmentSorting.subscribe(function () {
        self.GetUserAccountAssignmentCollection(false);
    });
    self.UserAccountAssignmentCollection = ko.observableArray([]);
    self.SelectUserAccountAssignmentRow = function (item) {
        self.SelectedUserAccountAssignmentRow(item);
        return true;
    };
    self.SelectedUserAccountAssignmentRow = ko.observable();
    self.SelectedUserAccountAssignmentRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.CompleteCheck = function () {
        return true;
    };
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "UserMandatorAdd":
                self.ShowUserMandatorDialog(self.User.UserId(), null, true);
                break;
            case "UserMandatorEdit":
                self.EditUserMandatorRow();
                break;
            case "UserMandatorDelete":
                self.DeleteUserMandatorRow();
                break;
            case "UserCustomerAdd":
                self.AddUserCustomerRow();
                break;
            case "UserCustomerEdit":
                self.EditUserCustomerRow();
                break;
            case "UserCustomerDelete":
                self.DeleteUserCustomerRow();
                break;
            case "UserLocationAdd":
                self.AddUserLocationRow();
                break;
            case "UserLocationDelete":
                self.DeleteUserLocationRow();
                break;
            case "UserAccountAssignmentAdd":
                self.AddUserAccountAssignmentRow();
                break;
            case "UserAccountAssignmentDelete":
                self.DeleteUserAccountAssignmentRow();
                break;
        }
    };
    self.ToolbarButtonsMandator = ko.observableArray([]);
    self.ToolbarButtonsMandator.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToolbarButtonsCustomer = ko.observableArray([]);
    self.ToolbarButtonsCustomer.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToolbarButtonsLocation = ko.observableArray([]);
    self.ToolbarButtonsLocation.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToolbarButtonsAccountAssignment = ko.observableArray([]);
    self.ToolbarButtonsAccountAssignment.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.EnableToolbarButtonsMandator = function (actionKey, enabled) { };
    self.EnableToolbarButtonsCustomer = function (actionKey, enabled) { };
    self.EnableToolbarButtonsLocation = function (actionKey, enabled) { };
    self.EnableToolbarButtonsAccountAssignment = function (actionKey, enabled) { };
    self.ToggleToolbarButtons = function () {
        self.EnableToolbarButtonsMandator("UserMandatorEdit", false);
        self.EnableToolbarButtonsMandator("UserMandatorDelete", false);
        self.EnableToolbarButtonsCustomer("UserCustomerAdd", false);
        self.EnableToolbarButtonsCustomer("UserCustomerEdit", false);
        self.EnableToolbarButtonsCustomer("UserCustomerDelete", false);
        self.EnableToolbarButtonsLocation("UserLocationAdd", false);
        self.EnableToolbarButtonsLocation("UserLocationDelete", false);
        self.EnableToolbarButtonsAccountAssignment("UserAccountAssignmentAdd", false);
        self.EnableToolbarButtonsAccountAssignment("UserAccountAssignmentDelete", false);
        if (self.SelectedUserMandatorRow() != null) {
            self.EnableToolbarButtonsMandator("UserMandatorEdit", true);
            self.EnableToolbarButtonsMandator("UserMandatorDelete", true);
            if (self.SelectedUserMandatorRow().EnableFilterCustomer == true) {
                self.EnableToolbarButtonsCustomer("UserCustomerAdd", true);
                if (self.SelectedUserCustomerRow() != null) {
                    self.EnableToolbarButtonsCustomer("UserCustomerEdit", true);
                    self.EnableToolbarButtonsCustomer("UserCustomerDelete", true);
                    if (self.SelectedUserCustomerRow().EnableFilterLocation == true) {
                        self.EnableToolbarButtonsLocation("UserLocationAdd", true);
                        if (self.SelectedUserLocationRow() != null) {
                            self.EnableToolbarButtonsLocation("UserLocationDelete", true);
                        }
                    }
                    if (self.SelectedUserCustomerRow().EnableFilterAccountAssignment == true) {
                        self.EnableToolbarButtonsAccountAssignment("UserAccountAssignmentAdd", true);
                        if (self.SelectedUserAccountAssignmentRow() != null) {
                            self.EnableToolbarButtonsAccountAssignment("UserAccountAssignmentDelete", true);
                        }
                    }
                }
            }
        }
    };
    self.GetUserMandatorCollection = function (resetPageSettings) {
        self.TabPage.IsLoading(true);
        if (resetPageSettings == true) {
            self.UserMandatorPageIndex(0);
        }
        return Bao.post("UadmCustom/UserTab/GetUserMandatorCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            pageIndex: self.UserMandatorPageIndex(),
            pageSize: self.UserMandatorPageSize(),
            sorting: self.UserMandatorSorting()
        }), function (result) {
            self.UserMandatorCollection(result.Models);
            self.UserMandatorTotalRows(result.TotalRows);
            self.SelectedUserMandatorRow(null);
            self.TabPage.IsLoading(false);
        });
    };
    self.GetUserCustomerCollection = function (resetPageSettings) {
        self.TabPage.IsLoading(true);
        if (resetPageSettings == true) {
            self.UserCustomerPageIndex(0);
        }
        var mandatorId = null;
        if (self.SelectedUserMandatorRow() != null) {
            mandatorId = self.SelectedUserMandatorRow().MandatorId;
        }
        return Bao.post("UadmCustom/UserTab/GetUserCustomerCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            mandatorId: mandatorId,
            pageIndex: self.UserCustomerPageIndex(),
            pageSize: self.UserCustomerPageSize(),
            sorting: self.UserCustomerSorting()
        }), function (result) {
            self.UserCustomerCollection(result.Models);
            self.UserCustomerTotalRows(result.TotalRows);
            self.SelectedUserCustomerRow(null);
            self.TabPage.IsLoading(false);
        });
    };
    self.GetUserLocationCollection = function (resetPageSettings) {
        self.TabPage.IsLoading(false);
        if (resetPageSettings == true) {
            self.UserLocationPageIndex(0);
        }
        var customerId = null;
        if (self.SelectedUserCustomerRow() != null) {
            customerId = self.SelectedUserCustomerRow().CustomerId;
        }
        return Bao.post("UadmCustom/UserTab/GetUserLocationCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            customerId: customerId,
            pageIndex: self.UserLocationPageIndex(),
            pageSize: self.UserLocationPageSize(),
            sorting: self.UserLocationSorting()
        }), function (result) {
            self.UserLocationCollection(result.Models);
            self.UserLocationTotalRows(result.TotalRows);
            self.SelectedUserLocationRow(null);
            self.TabPage.IsLoading(false);
        });
    };
    self.GetUserAccountAssignmentCollection = function (resetPageSettings) {
        self.TabPage.IsLoading(true);
        if (resetPageSettings == true) {
            self.UserAccountAssignmentPageIndex(0);
        }
        var customerId = null;
        if (self.SelectedUserCustomerRow() != null) {
            customerId = self.SelectedUserCustomerRow().CustomerId;
        }
        return Bao.post("UadmCustom/UserTab/GetUserAccountAssignmentCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            customerId: customerId,
            pageIndex: self.UserAccountAssignmentPageIndex(),
            pageSize: self.UserAccountAssignmentPageSize(),
            sorting: self.UserAccountAssignmentSorting()
        }), function (result) {
            self.UserAccountAssignmentCollection(result.Models);
            self.UserAccountAssignmentTotalRows(result.TotalRows);
            self.SelectedUserAccountAssignmentRow(null);
            self.TabPage.IsLoading(false);
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCustom/UserTab/ResetUserHierarchicalPermission", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId
        }), function () {
            self.GetUserMandatorCollection().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCustom/UserTab/SaveUserHierarchicalPermission", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            saveTime: parent.SaveTime()
        }));
    };
    self.Copy = function (userId, saveTime) {
        return Bao.post("UadmCustom/UserTab/CopyUserHierarchicalPermission", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            newUserId: userId,
            saveTime: saveTime
        }));
    };
    self.init = function () {
        return self.GetUserMandatorCollection();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.ShowUserMandatorDialog = function (userId, mandatorId, isNew) {
        window.baorequire(["UadmCustom/ViewModels/Dialogs/UserMandatorDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(userId, mandatorId, isNew);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.TabPage.IsLoading(true);
                    return Bao.post("UadmCustom/UserTab/AddUserMandator", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userId: self.User.UserId(),
                        mandatorId: dialog.DialogViewModel.MandatorId(),
                        enableFilterCustomer: dialog.DialogViewModel.EnableFilterCustomer()
                    }), function () {
                        self.GetUserMandatorCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            });
        });
    };
    self.EditUserMandatorRow = function () {
        if (self.SelectedUserMandatorRow() != null) {
            self.ShowUserMandatorDialog(self.User.UserId(), self.SelectedUserMandatorRow().MandatorId, false);
        }
    };
    self.DeleteUserMandatorRow = function () {
        if (self.SelectedUserMandatorRow() != null) {
            var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _removeMessageUserMandator, "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.TabPage.IsLoading(true);
                    return Bao.post("UadmCustom/UserTab/DeleteUserMandator", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userMandatorId: self.SelectedUserMandatorRow().UserMandatorId
                    }), function () {
                        self.GetUserMandatorCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    self.ShowUserCustomerDialog = function (userId, mandatorId, customerId, isNew) {
        window.baorequire(["UadmCustom/ViewModels/Dialogs/UserCustomerDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(userId, mandatorId, customerId, isNew);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.TabPage.IsLoading(true);
                    return Bao.post("UadmCustom/UserTab/AddUserCustomer", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userId: self.User.UserId(),
                        mandatorId: mandatorId,
                        customerId: dialog.DialogViewModel.CustomerId(),
                        enableFilterLocation: dialog.DialogViewModel.EnableFilterLocation(),
                        enableFilterAccountAssignment: dialog.DialogViewModel.EnableFilterAccountAssignment()
                    }), function () {
                        self.GetUserCustomerCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            });
        });
    };
    self.AddUserCustomerRow = function () {
        if (self.SelectedUserMandatorRow() != null) {
            self.ShowUserCustomerDialog(self.User.UserId(), self.SelectedUserMandatorRow().MandatorId, null, true);
        }
    };
    self.EditUserCustomerRow = function () {
        if (self.SelectedUserMandatorRow() != null && self.SelectedUserCustomerRow() != null) {
            self.ShowUserCustomerDialog(self.User.UserId(), self.SelectedUserMandatorRow().MandatorId, self.SelectedUserCustomerRow().CustomerId, false);
        }
    };
    self.DeleteUserCustomerRow = function () {
        if (self.SelectedUserCustomerRow() != null) {
            var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _removeMessageUserCustomer, "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.TabPage.IsLoading(true);
                    return Bao.post("UadmCustom/UserTab/DeleteUserCustomer", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userCustomerId: self.SelectedUserCustomerRow().UserCustomerId
                    }), function () {
                        self.GetUserCustomerCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    self.AddUserLocationRow = function () {
        if (self.SelectedUserMandatorRow() != null && self.SelectedUserCustomerRow() != null) {
            var baoSearchDialog = new BaoSearchDialog();
            var config = {
                MultiSelect: true,
                ObjectId: ko.observable(),
                ObjectValue: "Location",
                SearchType: "Location",
                AutoSearch: true,
                CustomFilter: {
                    MandatorId: self.SelectedUserMandatorRow().MandatorId,
                    CustomerId: self.SelectedUserCustomerRow().CustomerId
                },
                ApplyItemCallback: function (searchViewModel) {
                    var locationIds = [];
                    ko.utils.arrayForEach(searchViewModel.Selection(), function (item: any) {
                        locationIds.push(item.LocationId);
                    });
                    self.TabPage.IsLoading(true);
                    Bao.post("UadmCustom/UserTab/AddUserLocation", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userId: self.User.UserId(),
                        customerId: self.SelectedUserCustomerRow().CustomerId,
                        locationIds: locationIds
                    }), function () {
                        self.GetUserLocationCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            };
            baoSearchDialog.InitSearcher(config);
        }
    };
    self.DeleteUserLocationRow = function () {
        if (self.SelectedUserLocationRow() != null) {
            var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _removeMessageUserLocation, "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.TabPage.IsLoading(true);
                    return Bao.post("UadmCustom/UserTab/DeleteUserLocation", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userLocationId: self.SelectedUserLocationRow().UserLocationId
                    }), function () {
                        self.GetUserLocationCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    self.ShowUserAccountAssignmentDialog = function (userId, mandatorId, customerId, accountAssignmentTypeId, accountAssignment) {
        window.baorequire(["UadmCustom/ViewModels/Dialogs/UserAccountAssignmentDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(userId, mandatorId, customerId, accountAssignmentTypeId, accountAssignment);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    return Bao.post("UadmCustom/UserTab/AddUserAccountAssignment", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userId: self.User.UserId(),
                        customerId: self.SelectedUserCustomerRow().CustomerId,
                        accountAssignmentTypeId: dialog.DialogViewModel.AccountAssignmentTypeId(),
                        accountAssignment: dialog.DialogViewModel.AccountAssignment()
                    }), function () {
                        self.GetUserAccountAssignmentCollection(true);
                    });
                }
            });
        });
    };
    self.AddUserAccountAssignmentRow = function () {
        if (self.SelectedUserMandatorRow() != null && self.SelectedUserCustomerRow() != null) {
            self.ShowUserAccountAssignmentDialog(self.User.UserId(), self.SelectedUserMandatorRow().MandatorId, self.SelectedUserCustomerRow().CustomerId, null, true);
        }
    };
    self.DeleteUserAccountAssignmentRow = function () {
        if (self.SelectedUserAccountAssignmentRow() != null) {
            var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _removeMessageUserAccountAssignment, "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.TabPage.IsLoading(true);
                    return Bao.post("UadmCustom/UserTab/DeleteUserAccountAssignment", JSON.stringify({
                        sessionTabId: self.User.TabPage.SessionTabId,
                        userAccountAssignmentId: self.SelectedUserAccountAssignmentRow().UserAccountAssignmentId
                    }), function () {
                        self.GetUserAccountAssignmentCollection(true);
                        self.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
}
;
export default UserHierarchicalPermissionViewModel;